import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MoedaService } from '../moeda-service/moeda.service';
import { CrudBase } from './../../../../shared/crud/CrudBase';
import { ListitemBuilder } from './../../../../shared/dropdown-list/ListItemBuilder';
import { FiltroService } from './../../../../shared/filtro/filtro.service';
import { Estado } from './../../../../shared/shared/estado.enum';
import { TextBoxComponent } from './../../../../shared/text-box/text-box.component';

@Component({
  selector: 'app-moeda-cadastro',
  templateUrl: './moeda-cadastro.component.html',
  styleUrls: ['./moeda-cadastro.component.css']
})
export class MoedaCadastroComponent extends CrudBase implements OnInit {

  @ViewChild('inputValor') inputValor: TextBoxComponent;

  meses:any;

  carregando = false;

  constructor(service: MoedaService,
    toastr: ToastrService,
    private filtroService: FiltroService,) { 
      super(service, toastr);
    }

  ngOnInit(): void {
    if (!this.model) {
      this.model = {};
    }
    this.defineModelVazio();
    this.carregarMeses();
  }

  novo() {
    super.novo();
    this.defineModelVazio();
  }

  salvar() {
    this.model.valor = + (this.model.valor.toString().replace(/[.]/g, "")
      .replace(",", "."));
    
    super.salvar();
    
  }

  // == [ INICIO: Métodos Auxiliares ] ==
private defineModelVazio() {
  if (this.state === Estado.insert) {
    this.model.id = null;
    this.model.mes = '';
  }
}
// == [ FIM:    Métodos Auxiliares ] ==

private carregarMeses() {
  this.meses =
  new ListitemBuilder()
    .add('1', 'Janeiro')
    .add('2', 'Fevereiro')
    .add('3', 'Março')
    .add('4', 'Abril')
    .add('5', 'Maio')
    .add('6', 'Junho')
    .add('7', 'Julho')
    .add('8', 'Agosto')
    .add('9', 'Setembro')
    .add('10', 'Outubro')
    .add('11', 'Novembro')
    .add('12', 'Dezembro')
    .build();
}

}
